module.exports = __webpack_public_path__ + "static/media/gitnpm.0bc57ec2.png";